import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import {provideHttpClient, withFetch, withInterceptors} from "@angular/common/http";
import {cookieInterceptor} from "../interceptors/cookie.interceptor";
import {httpSpinnerInterceptor} from "../interceptors/http-spinner.interceptor";
import {xdebugInterceptor} from "../interceptors/xdebug.interceptor";
import {returnToLoginInterceptor} from "../interceptors/return-to-login.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes), provideClientHydration(), provideHttpClient(withFetch(), withInterceptors([cookieInterceptor, httpSpinnerInterceptor, xdebugInterceptor, returnToLoginInterceptor]))]
};
